import {ThunkDispatch} from 'redux-thunk';
import {APIS} from '../../api';
import {RootState} from '../../index';
import {
    GET_SERVICE_DELIVERY,
    ServiceDeliveryActionTypes,
    GETTING_SERVICE_DELIVERY,
    ADDING_SERVICE_DELIVERY,
    ADD_SERVICE_DELIVERY,
    DELETE_SERVICE_DELIVERY,
    GET_SERVICE_DELIVERY_ERROR,
    UPDATING_SERVICE_DELIVERY,
    UPDATE_SERVICE_DELIVERY,
    EXPORTING_SERVICE_DELIVERY,
    EXPORT_SERVICE_DELIVERY,
    PURGE_SERVICE_DELIVERY,
    ServiceDelivery,
    ADD_INTERVENTION_ERROR,
    ADD_INTERVENTION_SUCCESS,
    GET_SD, DELETE_INTERVENTION,
} from './type';
import {SnackBarActionTypes, SHOW_SNACK_BAR} from '../snackBar/types';
import {showSnackBar} from '../snackBar/actions';
import {errorMsg} from '../../utils';

// GET_SERVICE_DELIVERY INTERVENTION
export const getServiceDelivery =
    (page?: number, perPage?: number) => async (dispatch: ThunkDispatch<RootState, undefined, ServiceDeliveryActionTypes | SnackBarActionTypes>) => {
        console.log('[DEBUG getServiceDelivery] Called with page:', page, 'perPage:', perPage);
        dispatch({
            type: GETTING_SERVICE_DELIVERY,
        });
        try {
            const ServiceDeliveryPaginated = await APIS.serviceDelivery.getServiceDeliveryListGTI(page, perPage);
            console.log('[DEBUG getServiceDelivery] API response:', ServiceDeliveryPaginated);
            console.log('[DEBUG getServiceDelivery] Response type:', typeof ServiceDeliveryPaginated);
            console.log('[DEBUG getServiceDelivery] Has items?', !!ServiceDeliveryPaginated?.items);

            const newServiceDelivery: ServiceDelivery[] = [];
            const serviceDeliveryFromWs = ServiceDeliveryPaginated?.items ? ServiceDeliveryPaginated.items : (Array.isArray(ServiceDeliveryPaginated) ? ServiceDeliveryPaginated : []);
            console.log('[DEBUG getServiceDelivery] serviceDeliveryFromWs:', serviceDeliveryFromWs);
            console.log('[DEBUG getServiceDelivery] Is array?', Array.isArray(serviceDeliveryFromWs));
            
            if (serviceDeliveryFromWs && Array.isArray(serviceDeliveryFromWs) && serviceDeliveryFromWs.length > 0) {
                serviceDeliveryFromWs.map((item) => {
                    const serviceDelivery = {...item, firstname: null, type: null};
                    if (item.collaborators && item.collaborators[0]) {
                        serviceDelivery.firstname = item.collaborators[0].firstname;
                    }
                    if (item.types && item.types[0]) {
                        serviceDelivery.type = item.types[0].type;
                    }
                    newServiceDelivery.push({...serviceDelivery});
                });
            }
            if (ServiceDeliveryPaginated && typeof ServiceDeliveryPaginated === 'object') {
                ServiceDeliveryPaginated.items = [...newServiceDelivery];
            }
            dispatch({
                type: GET_SERVICE_DELIVERY,
                payload: ServiceDeliveryPaginated,
            });
        } catch (error) {
            console.error('[DEBUG getServiceDelivery] Error:', error);
            dispatch({
                type: SHOW_SNACK_BAR,
                payload: {message: errorMsg(error), severity: 'error'},
            });
            dispatch({
                type: GET_SERVICE_DELIVERY_ERROR,
            });
        }
    };

// GET SERVICE DELIVERY BY ID
export const getServiceDeliveryById =
    (id: string, page?: number, perPage?: number) =>
        async (dispatch: ThunkDispatch<RootState, undefined, ServiceDeliveryActionTypes | SnackBarActionTypes>) => {
            try {
                const response = await APIS.serviceDelivery.getServiceDeliveryBYID(id, page, perPage);
                dispatch(getServiceDelivery(1, 5));
                dispatch({
                    type: GET_SD,
                    payload: response,
                });
                return true;
        } catch (error) {
            throw error;
        }
    };
export const getServiceDeliveryByPatrimoine =
    (id: string[]) =>
        async (dispatch: ThunkDispatch<RootState, undefined, ServiceDeliveryActionTypes | SnackBarActionTypes>) => {
            try {
                const response = await APIS.serviceDelivery.getServiceDeliveryBYPAT(id);
                dispatch({
                    type: GET_SERVICE_DELIVERY,
                    payload: response,
                });
                return true;
        } catch (error) {
            throw error;
        }
    };
// GET_SERVICE_DELIVERY Planning
export const getServiceDeliveryPlanning =
    () => async (dispatch: ThunkDispatch<RootState, undefined, ServiceDeliveryActionTypes | SnackBarActionTypes>) => {
        dispatch({
            type: GETTING_SERVICE_DELIVERY,
        });
        try {
            const response = await APIS.serviceDelivery.getServiceDeliveryList();
            const newServiceDelivery: ServiceDelivery[] = [];
            
            // Response is an object {calendar: [...], collabs: [...], ...}
            // Extract the calendar array, which contains days with tasks
            const calendarDays = response?.calendar;
            const deliveryList = Array.isArray(calendarDays) ? calendarDays : [];
            
            deliveryList.forEach((day) => {
                // Each day has a "tasks" property containing service deliveries
                const tasks = day?.tasks;
                if (tasks && Array.isArray(tasks) && tasks.length > 0) {
                    tasks.forEach((task) => {
                        let newTask = {
                            ...task,
                            date: task.date || day.date,
                            id: task.id,
                            outOfStock: task.outOfStock,
                            refPat: task.refPat,
                            status: task.status,
                            weekTemplateId: task.weekTemplateId,
                            initialTimeRange: task.initialTimeRange,
                        };
                        if (task?.types && task?.types[0]) {
                            newTask = {
                                ...newTask,
                                type: task?.types[0]?.type,
                                duration: task?.types[0]?.duration,
                                type_id: task?.types[0]?.id
                            };
                        } else {
                            newTask = {...newTask, type: '', duration: '', type_id: null};
                        }
                        newServiceDelivery.push(newTask);
                    });
                }
            });

            dispatch({
                type: GET_SERVICE_DELIVERY,
                payload: newServiceDelivery,
            });
        } catch (error) {
            dispatch({
                type: SHOW_SNACK_BAR,
                payload: {message: errorMsg(error), severity: 'error'},
            });
            dispatch({
                type: GET_SERVICE_DELIVERY_ERROR,
            });
        }
    };
// DELETE SERVICE_DELIVERY_FROM_CALANDAR
export const deleteServiceDeliveryCalendar =
    (id: string) => async (dispatch: ThunkDispatch<RootState, undefined, ServiceDeliveryActionTypes | SnackBarActionTypes>) => {
        await APIS.serviceDelivery.deleteServiceDelivery(id);
        dispatch(showSnackBar('intervention.delete_success', 'success'));
        dispatch(getServiceDeliveryPlanning());
        dispatch({
            type: DELETE_SERVICE_DELIVERY,
            payload: id,
        });

        return true;
    };
// DELETE SERVICE_DELIVERY
export const deleteServiceDelivery =
    (id: string) => async (dispatch: ThunkDispatch<RootState, undefined, ServiceDeliveryActionTypes | SnackBarActionTypes>) => {
        await APIS.serviceDelivery.deleteServiceDelivery(id);
        dispatch(showSnackBar('intervention.delete_success', 'success'));
        dispatch(getServiceDelivery(1, 5));
        dispatch({
            type: DELETE_SERVICE_DELIVERY,
            payload: id,
        });

        return true;
    };

// ADD SERVICE_DELIVERY
export const addServiceDelivery =
    (date: string, initialTimeRange: string[], isIntervention: boolean, refPat: string, serviceDeliveryTypeIds: string[], collabIds: string[], status?: string) =>
        async (dispatch: ThunkDispatch<RootState, undefined, ServiceDeliveryActionTypes | SnackBarActionTypes>) => {
            dispatch({
                type: ADDING_SERVICE_DELIVERY,
            });
            try {
                await APIS.serviceDelivery.addNewServiceDelivery({
                    date,
                    initialTimeRange,
                    isIntervention,
                    refPat,
                    serviceDeliveryTypeIds,
                    collabIds,
                    ...(status && { status }),
                });
                dispatch(showSnackBar('intervention.add_success', 'success'));
                dispatch(getServiceDeliveryPlanning());
                dispatch({
                    type: ADD_SERVICE_DELIVERY,
                });
                return true;
            } catch (error) {
                dispatch({
                    type: SHOW_SNACK_BAR,
                    payload: {message: errorMsg(error), severity: 'error'},
                });
                dispatch({
                    type: ADD_SERVICE_DELIVERY,
                });
                throw error;
            }
        };

// EDIT SERVICE_DELIVERY
export const editServiceDelivery =
    (
        id: string,
        date: string,
        initialTimeRange: string[],
        actualTimeRange: [],
        isIntervention: boolean,
        refPat: string,
        comment: string,
    ) =>
        async (dispatch: ThunkDispatch<RootState, undefined, ServiceDeliveryActionTypes | SnackBarActionTypes>) => {
            try {
                await APIS.serviceDelivery.editServiceDel(id, {
                    date,
                    initialTimeRange,
                    actualTimeRange,
                    isIntervention,
                    refPat,
                    comment
                });
                dispatch(showSnackBar('intervention.update_success', 'success'));
                dispatch(getServiceDelivery());
                dispatch({
                    type: UPDATING_SERVICE_DELIVERY,
                });
                return true;
            } catch (error) {
                dispatch({
                    type: SHOW_SNACK_BAR,
                    payload: {message: errorMsg(error), severity: 'error'},
                });
                dispatch({
                    type: UPDATE_SERVICE_DELIVERY,
                });
                throw error;
            }
        };

// EXPORT_SERVICE_DELIVERIES
export const exportServiceDelivery =
    (exportType: string, startDate: string, endDate: string) =>
        async (dispatch: ThunkDispatch<RootState, undefined, ServiceDeliveryActionTypes | SnackBarActionTypes>) => {
            dispatch({
                type: EXPORTING_SERVICE_DELIVERY,
            });

            try {
                await APIS.serviceDelivery.exportServiceDelivery(exportType, startDate, endDate);
                dispatch(showSnackBar('intervention.export_success', 'success'));
                dispatch({
                    type: EXPORT_SERVICE_DELIVERY,
                });
                return true;
            } catch (error) {
                dispatch({
                    type: SHOW_SNACK_BAR,
                    payload: {message: errorMsg(error), severity: 'error'},
                });

                dispatch({
                    type: EXPORT_SERVICE_DELIVERY,
                });
                throw error; // Propager l'erreur pour que le dialog puisse réagir
            }
        };

// PURGE_SERVICE_DELIVERIES
export const purgeServiceDelivery =
    (startDate: string) => async (dispatch: ThunkDispatch<RootState, undefined, ServiceDeliveryActionTypes | SnackBarActionTypes>) => {
        try {
            await APIS.serviceDelivery.purgeServiceDelivery(startDate);
            dispatch(showSnackBar('intervention.purge_success', 'success'));
            dispatch(getServiceDelivery(1, 5));
            dispatch({
                type: PURGE_SERVICE_DELIVERY,
            });
        } catch (error) {
            dispatch({
                type: SHOW_SNACK_BAR,
                payload: {message: errorMsg(error), severity: 'error'},
            });
            dispatch({
                type: GET_SERVICE_DELIVERY_ERROR,
            });
        }
    };

// ADD SERVICE_DELIVERY
export const addIntervention =
    (
        date: string,
        initialTimeRange: string[],
        isIntervention: boolean,
        refPat: string,
        comment: string,
        serviceDeliveryTypeIds: string[],
        collabIds: string[],
    ) =>
        async (dispatch: ThunkDispatch<RootState, undefined, ServiceDeliveryActionTypes | SnackBarActionTypes>) => {
            console.log('[DEBUG addIntervention] Called with:', { date, initialTimeRange, isIntervention, refPat, comment, serviceDeliveryTypeIds, collabIds });
            dispatch({
                type: ADDING_SERVICE_DELIVERY,
            });
            try {
                const result = await APIS.serviceDelivery.addIntervention({
                    date,
                    initialTimeRange,
                    isIntervention,
                    refPat,
                    comment,
                    serviceDeliveryTypeIds,
                    collabIds,
                });
                console.log('[DEBUG addIntervention] API response:', result);
                dispatch(getServiceDelivery(1, 5));
                dispatch({
                    type: ADD_INTERVENTION_SUCCESS,
                });
            } catch (error) {
                console.error('[DEBUG addIntervention] Error:', error);
                dispatch({
                    type: SHOW_SNACK_BAR,
                    payload: {message: errorMsg(error), severity: 'error'},
                });
                dispatch({
                    type: ADD_INTERVENTION_ERROR,
                });
            }
        };
// DELETE INTERVENTION
export const deleteIntervention =
    (id: string) => async (dispatch: ThunkDispatch<RootState,
        undefined, ServiceDeliveryActionTypes | SnackBarActionTypes>) => {
        await APIS.calendarService.deleteIntervention(id);
        dispatch(showSnackBar('intervention.delete_success', 'success'));
        dispatch(getServiceDelivery(1, 5));
        dispatch({
            type: DELETE_INTERVENTION,
            payload: id,
        });

        return true;
    };

// UPDATE SERVICE_DELIVERY STATUS
export const updateServiceDeliveryStatus =
    (
        id: string,
        timeIn: string,
        timeOut: string,
        status: string,
        comment: string,
        outOfStock: boolean,
        date: string,
    ) =>
        async (dispatch: ThunkDispatch<RootState, undefined, ServiceDeliveryActionTypes | SnackBarActionTypes>) => {
            try {
                await APIS.serviceDelivery.updateServiceDelStatus(id, {
                    timeIn,
                    timeOut,
                    status,
                    comment,
                    outOfStock,
                    date
                });
                dispatch(showSnackBar('intervention.update_success', 'success'));
                dispatch(getServiceDelivery());
                dispatch({
                    type: UPDATING_SERVICE_DELIVERY,
                });
                return true;
            } catch (error) {
                dispatch({
                    type: SHOW_SNACK_BAR,
                    payload: {message: errorMsg(error), severity: 'error'},
                });
                dispatch({
                    type: UPDATE_SERVICE_DELIVERY,
                });
                throw error;
            }
        };
